import store from '@/store'

function isLoading() {
  return store.getters.isLoading
}

const setLoading = state => {
  store.dispatch('loading', state)
}

export default {
  setLoading,
  isLoading
}
